import { useMemo } from 'react';

import AvailabilitiesErrorContainer from 'reservations/availabilities/components/AvailabilitiesErrorContainer';
import { getNoAvailabilitiesMessage } from 'reservations/availabilities/helpers/getNoAvailabilitiesMessage';
import { COMMON_DATETIME_FORMATS } from 'reservations/base/helpers/datetime';

export type NoAvailabilitiesProps = {
  date: Date;
  partySize: number;
  phoneNumber: string;
  emailAddress: string;
};

export const NoAvailabilities = ({
  date,
  partySize,
  phoneNumber,
  emailAddress
}: NoAvailabilitiesProps) => {
  const formattedDate = useMemo(
    () => COMMON_DATETIME_FORMATS.dayDateOnly(date),
    [date]
  );

  return (
    <AvailabilitiesErrorContainer
      message={getNoAvailabilitiesMessage({
        partySize,
        date: formattedDate,
        phoneNumber: phoneNumber,
        emailAddress: emailAddress
      })}
    />
  );
};
